import React, { memo } from "react";
import { observer } from "mobx-react";
import PopupForm from "app/common/Component/Popup/PopupForm";
import { Grid, Tooltip, useMediaQuery, useTheme } from "@material-ui/core";
import TableComponent from "app/common/Component/Table/TableComponent";
import { useTranslation } from "react-i18next";
import CommonButton from "app/common/Component/Button/CommonButton";
import { Block, Save } from "@material-ui/icons";
import GlobitsNumberInput from "app/common/form/GlobitsNumberInput";

function UpdateTreatmentTotalPopup({ open, handleClose, handleSubmit }) {
  const { t } = useTranslation();
  const urlParams = new URLSearchParams(window.location.search);
  const patientId = urlParams.get("patientId");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  return (
    <PopupForm
      size="xs"
      title="Cập nhật số lần điều trị "
      open={open}
      handleClose={handleClose}
      formik={{
        initialValues: { ...open, totaltreat: null },
        onSubmit: handleSubmit,
        enableReinitialize: true,
      }}
      action={({ isSubmitting, setFieldValue, submitForm }) => {
        return (
          <div className="flex-center gap-1">
            <CommonButton
              type="submit"
              className="btn-primary"
              disabled={isSubmitting}
            >
              {!isMobile && <Save className="mr-2 " />}
              {`Cập nhật tổng số lần điều trị`}
            </CommonButton>

            <CommonButton className="btn-gray" onClick={handleClose}>
              <Block className="mr-2" /> Đóng
            </CommonButton>
          </div>
        );
      }}
    >
      <Grid container spacing={1}>
        <Grid
          item
          xs={12}
          className="justify-center cards-body pt-0 mt-2"
          style={{
            zIndex: 1,
            position: "relative",
          }}
        >
          <GlobitsNumberInput
            name={`totaltreat`}
            label="Tổng số lần cập nhật"
          />
        </Grid>
      </Grid>
    </PopupForm>
  );
}

export default memo(observer(UpdateTreatmentTotalPopup));
